module.exports = __webpack_public_path__ + "static/media/house-large.d8c92cb5.webp";